import { RefundSummaryResponse } from '../api/responses/refund-summary.response';
import { RefundSummary } from '../models/refund-summary';

export const refundSummaryFromResponse = (
  response: RefundSummaryResponse,
): RefundSummary => {
  return new RefundSummary({
    refundedPrice: response.refundedPrice,
    originalPrice: response.originalPrice,
    currentPrice: response.currentPrice,
  });
};
